// extracted by mini-css-extract-plugin
export default {"glassContainer":"Modal_glassContainer__Qu4Iy","dialogTitle":"Modal_dialogTitle__qfbjs","dialogBorders":"Modal_dialogBorders__Xp1C3","dialogContent":"Modal_dialogContent__jYpxR"};